<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black">กำลังโหลดข้อมูล...</p>
</ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">

    <div class="col-md-12">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-md-5">
                        <h1 class="headText2 text-primary">บันทึกข้อมูล จดแจ้ง รายชาวไร่ ปี {{year_S[0]}}</h1>
                        <b *ngIf="Selectfarmer.length>0"> โซน: {{zone}} ,นอส: {{supcode}} ,จำนวนชาวไร่:
                            {{Selectfarmer.length|number}} ราย</b>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="fill">
                            <mat-label>กรุณาเลือกปี </mat-label>
                            <mat-select disableRipple required [(ngModel)]="year_S" (selectionChange)="select_year()">
                                <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
                                <mat-option *ngFor="let item of year_L" [value]="item">{{item[4]}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!--<div class="col-md-2" *ngIf="Selectfarmer.length > 0">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกโซน/ส่วน</mat-label>
                            <mat-select disableRipple required [(ngModel)]="selectS" (ngModelChange)="select_year()">
                                <mat-option *ngFor="let item of selectsup" [value]="item">
                                    {{item[3]}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>-->
                </div>
            </div>
            <div class="card-body">
                <div class="row justify-content-md-center">
                    <div class="col-md-9" *ngIf="Selectfarmer.length>0">
                        <div class="card">
                            <div class="card-body">
                                <div class="row" style="text-align:center;">
                                    <div class="col-md-5">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-label>ค้นหาชาวไร่</mat-label>
                                            <input matInput [(ngModel)]="S_texe" placeholder="Search Here">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="example-button-row">
                                            <button mat-raised-button color="primary">ค้นหา</button>
                                        </div>
                                    </div>
                                    <div class="col-md-2" *ngIf="Selectfarmer.length > 0">
                                        <div class="button-row">
                                            <button mat-raised-button color="primary" [disabled]="edit_st != 0"
                                                (click)="Loaddatacontact()"><mat-icon> update
                                                </mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="button-row">
                                            <button mat-raised-button *ngIf="edit_st == 0" (click)="edit_st = 1">
                                                <mat-icon style="color: blue;">edit</mat-icon>
                                            </button>
                                            <button mat-raised-button *ngIf="edit_st != 0" (click)="saveData();">
                                                <mat-icon style="color: green;"> done </mat-icon>บันทึก
                                            </button>
                                            <button mat-raised-button *ngIf="edit_st != 0" (click)="edit_st = 0">
                                                <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-body table-responsive p-2" style="height: 600px">
                                <table
                                    class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap"
                                    style="width:100%">
                                    <thead>
                                        <tr style="text-align:center;">
                                            <th>No</th>
                                            <th>โควตา</th>
                                            <th>ชื่อชาวไร่</th>
                                            <th>โซน</th>
                                            <th>ขยาย</th>
                                            <th>รื้อตอ</th>
                                            <th>อ้อยตอ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align:center;"
                                            *ngFor="let item of Selectfarmer | filter:S_texe; index as i"
                                            [ngSwitch]="edit_st">
                                            <td>{{i+1}}</td>
                                            <td>{{item.fmcode}}</td>
                                            <td>{{item.fmname}}</td>
                                            <td>{{item.SUPZONE}}</td>
                                            <td><input *ngSwitchCase="1" type="number" matInput
                                                    style="text-align:center; background: #b7f89d;" min="0"
                                                    [ngModel]="item.inform_ERN"
                                                    (ngModelChange)="item.inform_ERN = $event; item.modify = true;" />
                                                <div *ngSwitchCase="0">{{item.inform_ERN | number}}</div>
                                            </td>
                                            <td><input *ngSwitchCase="1" type="number" matInput
                                                    style="text-align:center; background: #e5f5a0;" min="0"
                                                    [ngModel]="item.inform_ERO"
                                                    (ngModelChange)="item.inform_ERO = $event; item.modify = true;" />
                                                <div *ngSwitchCase="0">{{item.inform_ERO | number}}</div>
                                            </td>
                                            <td><input *ngSwitchCase="1" type="number" matInput
                                                    style="text-align:center; background: #f7cf94;" min="0"
                                                    [ngModel]="item.inform_ST"
                                                    (ngModelChange)="item.inform_ST = $event; item.modify = true;" />
                                                <div *ngSwitchCase="0">{{item.inform_ST | number}}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>